<script lang="ts">
  import {configurationsStore} from '@/store';
  import {Configuration, SupportedConfigurations} from '@/types/settings';
  import Swal from 'sweetalert2';
  import {YtdlpConfigurations} from './components';

  const configPromise = configurationsStore.getAll();

  let isLoading = false;

  const handleDelete = async (type: SupportedConfigurations, name: string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this configuration!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      isLoading = true;
      await configurationsStore.remove(type, name);
      Swal.fire({
        position: 'bottom-end',
        icon: 'success',
        title: 'Configuration Deleted',
        showConfirmButton: false,
        timer: 1500,
        toast: true
      });
    }
    isLoading = false;
  };

  const handleAdd = async (configuration: Configuration) => {
    isLoading = true;
    await configurationsStore.create(configuration);
    Swal.fire({
      position: 'bottom-end',
      icon: 'success',
      title: `${configuration.type} Configuration Added`,
      showConfirmButton: false,
      timer: 1500,
      toast: true
    });
    isLoading = false;
  };
</script>

<div class="p-4">
  {#await configPromise}
    <div class="flex flex-col gap-2">
      <span>Loading configurations...</span>
    </div>
  {:then}
    {#if $configurationsStore.length === 0}
      <div class="flex flex-col gap-2">
        <span>No configurations found</span>
      </div>
    {:else}
      <div class="space-y-3">
        {#each $configurationsStore as configuration}
          <div class="flex flex-col gap-2">
            {#if configuration.type === 'ytdlp'}
              <YtdlpConfigurations
                {isLoading}
                {configuration}
                on:deleteCookie={e => handleDelete(configuration.type, e.detail)}
                on:addCookie={e => handleAdd(e.detail)}
              />
            {/if}
          </div>
        {/each}
      </div>
    {/if}
  {:catch error}
    <div class="flex flex-col gap-2">
      <span class="text-red-500">Error loading configurations: {error.message}</span>
    </div>
  {/await}
</div>
